import { RootState } from "@app/redux/store";

export const selectSettings = (state: RootState) => state.settings;
